// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".--big[data-v-0203fcdf]{width:4rem;min-width:4rem;height:4rem}.--small[data-v-0203fcdf]{width:2.4rem;min-width:2.4rem;height:2.4rem}", ""]);
// Exports
module.exports = exports;
